import { RouteParams } from "vue-router";

interface NavbarLink {
  to?: {
    name: string;
    params?: RouteParams;
  };
  icon: string;
  text: string;
  sublinks?: NavbarLink[];
}

export default (privs: string[], customerId: string): NavbarLink[] => {
  const links: NavbarLink[] = [
    {
      to: { name: "home" },
      icon: "fas fa-home",
      text: "Home",
    },
  ];

  if (!privs) {
    return links;
  }

  if (
    privs.includes("billing") ||
    privs.includes("deals") ||
    privs.includes("tickets")
  ) {
    links.push({
      to: { name: "documents" },
      icon: "fas fa-file-alt",
      text: "Documents",
    });
  }

  if (privs.includes("deals")) {
    links.push({
      to: {
        name: "calcsessions",
        params: { customerId },
      },
      icon: "fas fa-calculator",
      text: "Config Calc",
    });
    links.push({
      to: {
        name: "projects",
        params: { customerId },
      },
      icon: "fas fa-pencil-ruler",
      text: "Project Reg",
    });
  }

  if (privs.includes("orders")) {
    links.push({
      to: {
        name: "comingsoon",
        params: { id: "Order%20Status" },
      },
      icon: "fas fa-truck",
      text: "Order Status",
    });
  }

  if (privs.includes("register")) {
    links.push({
      to: {
        name: "register.int",
        params: { customerId },
      },
      icon: "fas fa-registered",
      text: "Register",
    });
  }

  if (privs.includes("tickets")) {
    links.push({
      icon: "fas fa-circle-question",
      text: "Support",
      sublinks: [
        {
          to: {
            name: "support.tickets",
            params: { customerId },
          },
          text: "Tickets",
          icon: "fas fa-ticket",
        },
        {
          to: {
            name: "comingsoon",
            params: { id: "RMA" },
          },
          text: "RMA",
          icon: "fas fa-arrow-right-arrow-left",
        },
      ],
    });
  }

  if (privs.includes("qxapi")) {
    links.push({
      icon: "fas fa-globe",
      text: "QxControl API",
      to: {
        name: "qx.api",
      },
    });
  }

  if (privs.includes("qxcStatus") || privs.includes("sysprep")) {
    links.push({
      icon: "fas fa-chart-line",
      text: "Ops Portal",
      to: {
        name: "ops.portal",
      },
    });
  }

  return links;
};
